if (!customElements.get('purchase-options')) {
  customElements.define(
    'purchase-options',
    class PurchaseOptions extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const pricesScript = this.querySelector('[data-purchase-options-prices]');
        try {
          this.prices = pricesScript ? JSON.parse(pricesScript.textContent) : {};
        } catch (error) {
          this.prices = {};
        }

        this.input = this.querySelector('.purchase-options__input');
        this.plansPanel = this.querySelector('.purchase-options__plans');
        this.subscriptionPrice = this.querySelector('[data-subscription-price]');
        this.subscriptionCompare = this.querySelector('[data-subscription-compare]');
        this.subscriptionSave = this.querySelector('[data-subscription-save]');

        this.addEventListener('change', this.onChange.bind(this));
        this.onPageShow = () => this.update();
        window.addEventListener('pageshow', this.onPageShow);

        this.update();
      }

      disconnectedCallback() {
        if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
      }

      onChange(event) {
        if (!event.target.matches('.purchase-options__type-radio, .purchase-options__plan-radio')) return;
        this.update();
      }

      get form() {
        return document.getElementById(this.dataset.form);
      }

      get isSubscription() {
        const checkedType = this.querySelector('.purchase-options__type-radio:checked');
        if (checkedType) return checkedType.value === 'subscription';
        return !this.querySelector('.purchase-options__type-radio[value="one_time"]');
      }

      get selectedPlanRadio() {
        const checked = this.querySelector('.purchase-options__plan-radio:checked');
        if (checked) return checked;
        const first = this.querySelector('.purchase-options__plan-radio');
        if (first) first.checked = true;
        return first;
      }

      get variantId() {
        const form = this.form;
        const idInput = form && form.querySelector('[name="id"]');
        return idInput ? idInput.value : Object.keys(this.prices)[0];
      }

      update() {
        const planRadio = this.isSubscription ? this.selectedPlanRadio : null;
        const sellingPlanId = planRadio ? planRadio.value : '';

        this.querySelectorAll('.purchase-options__type').forEach((label) => {
          const radio = label.querySelector('.purchase-options__type-radio');
          label.classList.toggle('purchase-options__type--selected', Boolean(radio && radio.checked));
        });
        this.querySelectorAll('.purchase-options__plan').forEach((label) => {
          const radio = label.querySelector('.purchase-options__plan-radio');
          label.classList.toggle('purchase-options__plan--selected', Boolean(radio && radio.checked));
        });
        if (this.plansPanel) this.plansPanel.hidden = !sellingPlanId;

        this.syncInput(sellingPlanId);
        this.dataset.sellingPlan = sellingPlanId;

        const variantPrices = this.prices[this.variantId] || this.prices[Object.keys(this.prices)[0]];
        if (variantPrices) {
          this.updateSubscriptionPrice(variantPrices, planRadio);
          this.updateThemePrice(sellingPlanId ? variantPrices.plans[sellingPlanId] : variantPrices.one_time);
        }

        const scope = this.closest('product-info') || this.closest('section') || document;
        scope.querySelectorAll('bundle-quantity-selector').forEach((selector) => {
          if (typeof selector.setSellingPlan === 'function') selector.setSellingPlan(sellingPlanId);
        });

        this.dispatchEvent(
          new CustomEvent('purchase-options:change', { bubbles: true, detail: { sellingPlanId: sellingPlanId } })
        );
      }

      syncInput(sellingPlanId) {
        const form = this.form;
        if (this.input && form && this.input.form === form && !form.contains(this.input)) {
          form.appendChild(this.input);
        }
        if (this.input) this.input.value = sellingPlanId;
      }

      updateSubscriptionPrice(variantPrices, planRadio) {
        const planId = planRadio ? planRadio.value : this.querySelector('.purchase-options__plan-radio')?.value;
        const plan = planId && variantPrices.plans[planId];
        if (!plan) return;
        if (this.subscriptionPrice) this.subscriptionPrice.textContent = plan.price;
        if (this.subscriptionCompare) {
          this.subscriptionCompare.textContent = plan.plan_compare;
          this.subscriptionCompare.hidden = !plan.plan_compare;
        }
        if (this.subscriptionSave) {
          this.subscriptionSave.textContent = plan.plan_save;
          this.subscriptionSave.hidden = !plan.plan_save;
        }
      }

      updateThemePrice(state) {
        const container = document.getElementById(this.dataset.price);
        if (!container || !state) return;

        container.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach((element) => {
          element.textContent = state.price;
        });
        container.querySelectorAll('.price__sale s.price-item--regular').forEach((element) => {
          element.textContent = state.compare;
        });
        container.querySelectorAll('.price').forEach((element) => {
          element.classList.toggle('price--on-sale', state.on_sale);
        });
        container.querySelectorAll('.price__badge-percent').forEach((element) => {
          element.textContent = state.badge;
          element.hidden = !state.on_sale;
        });
      }
    }
  );
}
